// Versie en deploy datum
export const APP_VERSION = '2.10.0';
// REACT_APP_BUILD_DATE wordt gezet in package.json build script
export const DEPLOY_DATE = process.env.REACT_APP_BUILD_DATE || '27 februari 2026';
